module.exports = __webpack_public_path__ + "static/media/Chin-Yi Cheng.2f9df76d.png";